module.exports = __webpack_public_path__ + "img/prod_img_home.a86aa049.png";